import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'kk',
  months: [
    'қаңтар',
    'ақпан',
    'наурыз',
    'сәуір',
    'мамыр',
    'маусым',
    'шілде',
    'тамыз',
    'қыргүйек',
    'қазан',
    'қараша',
    'желтоқсан',
  ],
  monthsShort: ['қаң', 'ақп', 'нау', 'сәу', 'мам', 'мау', 'шіл', 'там', 'қыр', 'қаз', 'қар', 'жел'],
  weekdays: ['жексенбі', 'дүйсенбі', 'сейсенбі', 'сәрсенбі', 'бейсенбі', 'жұма', 'сенбі'],
  weekdaysMin: ['Ж', 'Д', 'С', 'С', 'Б', 'Ж', 'С'],
  weekdaysShort: ['Жек', 'Дүй', 'Сей', 'Сәр', 'Бей', 'Жұм', 'Сен'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM, YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd D MMMM, YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M.',
    ll: 'YYYY [ж]. D MMM',
    'll-Y': 'D MMM',
    'll-D': 'YYYY [ж]. MMM',
    lll: 'YYYY [ж]. D MMM, HH:mm',
    'lll-Y': 'D MMM, H:mm',
    llll: 'YYYY [ж]. D MMM, ddd, HH:mm',
    'llll-Y': 'D MMM, ddd, HH:mm',
    'll-Y+w': 'D MMM, ddd',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'YYYY [ж]. D MMMM, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s ж. бұрын', other: '%s ж. бұрын' },
    M: { one: '%s ай бұрын', other: '%s ай бұрын' },
    w: { one: '%s ап. бұрын', other: '%s ап. бұрын' },
    d: { one: '%s күн бұрын', other: '%s күн бұрын' },
    h: { one: '%s сағ. бұрын', other: '%s сағ. бұрын' },
    m: { one: '%s мин. бұрын', other: '%s мин. бұрын' },
    s: { one: '%s сек. бұрын', other: '%s сек. бұрын' },
  },
  future: {
    y: { one: '%s ж. кейін', other: '%s ж. кейін' },
    M: { one: '%s айдан кейін', other: '%s айдан кейін' },
    w: { one: '%s ап. кейін', other: '%s ап. кейін' },
    d: { one: '%s күннен кейін', other: '%s күннен кейін' },
    h: { one: '%s сағ. кейін', other: '%s сағ. кейін' },
    m: { one: '%s мин. кейін', other: '%s мин. кейін' },
    s: { one: '%s сек. кейін', other: '%s сек. кейін' },
  },
  pastLong: {
    y: { one: '%s жыл бұрын', other: '%s жыл бұрын' },
    M: { one: '%s ай бұрын', other: '%s ай бұрын' },
    w: { one: '%s апта бұрын', other: '%s апта бұрын' },
    d: { one: '%s күн бұрын', other: '%s күн бұрын' },
    h: { one: '%s сағат бұрын', other: '%s сағат бұрын' },
    m: { one: '%s минут бұрын', other: '%s минут бұрын' },
    s: { one: '%s секунд бұрын', other: '%s секунд бұрын' },
  },
  futureLong: {
    y: { one: '%s жылдан кейін', other: '%s жылдан кейін' },
    M: { one: '%s айдан кейін', other: '%s айдан кейін' },
    w: { one: '%s аптадан кейін', other: '%s аптадан кейін' },
    d: { one: '%s күннен кейін', other: '%s күннен кейін' },
    h: { one: '%s сағаттан кейін', other: '%s сағаттан кейін' },
    m: { one: '%s минуттан кейін', other: '%s минуттан кейін' },
    s: { one: '%s секундтан кейін', other: '%s секундтан кейін' },
  },
  abbr: {
    y: { one: '%s жыл', other: '%s жыл' },
    M: { one: '%s ай', other: '%s ай' },
    w: { one: '%s апта', other: '%s апта' },
    d: { one: '%s күн', other: '%s күн' },
    h: { one: '%s сағ.', other: '%s сағ.' },
    m: { one: '%s мин.', other: '%s мин.' },
    s: { one: '%s сек.', other: '%s сек.' },
  },
  full: {
    y: { one: '%s жыл', other: '%s жыл' },
    M: { one: '%s ай', other: '%s ай' },
    w: { one: '%s апта', other: '%s апта' },
    d: { one: '%s күн', other: '%s күн' },
    h: { one: '%s сағат', other: '%s сағат' },
    m: { one: '%s минут', other: '%s минут' },
    s: { one: '%s секунд', other: '%s секунд' },
  },
  justNow: 'жаңа ғана',
  yesterday: 'Кеше',
  today: 'Бүгін',
  tomorrow: 'Ертең',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'YYYY [ж]. D MMMM', end: 'YYYY [ж]. D MMMM' },
    'yl-1': { start: 'D MMMM', end: 'YYYY [ж]. D MMMM' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'YYYY [ж]. D', end: 'D MMMM' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'YYYY [ж]. D MMM', end: 'YYYY [ж]. D MMM' },
    'y-1': { start: 'YYYY [ж]. D MMM', end: 'D MMM' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'YYYY [ж]. D MMM', end: 'D MMM' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'YYYY [ж]. D MMM, ddd', end: 'YYYY [ж]. D MMM, ddd' },
    'Y-1': { start: 'YYYY [ж]. D MMM, ddd', end: 'D MMM, ddd' },
    M: { start: 'D MMM, ddd', end: 'D MMM, ddd' },
    D: { start: 'D MMM, ddd', end: 'D MMM, ddd' },
    yt: { start: 'YYYY [ж]. D MMM, HH:mm', end: 'YYYY [ж]. D MMM, HH:mm' },
    mt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    dt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'YYYY [ж]. D MMM, HH:mm', end: 'YYYY [ж]. D MMM, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'kk';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
